import confetti from "canvas-confetti";

// SSU brand colors
const COLORS = ["#FACC15", "#0066FF", "#00B4D8", "#FFFFFF", "#EAB308"];

/**
 * Fires a celebratory fireworks-style confetti burst from both sides
 * of the viewport. Used when a form is successfully submitted.
 */
export function fireCelebration() {
  // Big initial bursts from both sides
  confetti({
    particleCount: 120,
    spread: 70,
    angle: 60,
    origin: { x: 0, y: 0.7 },
    startVelocity: 55,
    colors: COLORS,
    scalar: 1.1,
    ticks: 200,
  });
  confetti({
    particleCount: 120,
    spread: 70,
    angle: 120,
    origin: { x: 1, y: 0.7 },
    startVelocity: 55,
    colors: COLORS,
    scalar: 1.1,
    ticks: 200,
  });

  // Sustained side fireworks for ~3 seconds
  const end = Date.now() + 3000;
  (function frame() {
    confetti({
      particleCount: 4,
      angle: 60,
      spread: 75,
      startVelocity: 55,
      origin: { x: 0, y: 0.7 },
      colors: COLORS,
      ticks: 180,
    });
    confetti({
      particleCount: 4,
      angle: 120,
      spread: 75,
      startVelocity: 55,
      origin: { x: 1, y: 0.7 },
      colors: COLORS,
      ticks: 180,
    });
    if (Date.now() < end) requestAnimationFrame(frame);
  })();

  // Center finale burst after a short delay
  setTimeout(() => {
    confetti({
      particleCount: 80,
      spread: 110,
      origin: { x: 0.5, y: 0.55 },
      startVelocity: 45,
      colors: COLORS,
      scalar: 1.2,
      ticks: 220,
    });
  }, 800);
}
